// extracted by mini-css-extract-plugin
export var content = "ForgotPassword-module__content___mffGa";